export default __webpack_public_path__ + "static/media/chevron.229b3a5d.svg";